module.exports = __webpack_public_path__ + "43246681ce5b76ca39c41d6174d1fb1a.svg";